function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
import { PropTypes } from "prop-types";
// Material imports
import withStyles from "@mui/styles/withStyles";
import Tooltip from "@mui/material/Tooltip";
import Button from "@mui/material/Button";
// Limitless imports
import { withi18n } from "../../../../customer/components";
import { CORE_BUTTON_STYLES } from "../login-button/LoginButton";
const TooltipButton = ({
  t,
  classes,
  tooltipTitle,
  children,
  placement,
  buttonWrapperClassName,
  onClick,
  allowButtonClasses = true,
  buttonProps
}) => {
  const [open, setOpen] = React.useState(false);
  const handleTooltipClose = () => {
    setOpen(false);
  };
  const handleTooltipOpen = () => {
    setOpen(true);
  };
  const handleButtonClick = event => {
    handleTooltipClose();
    onClick(event);
  };
  return /*#__PURE__*/React.createElement(Tooltip, {
    placement: placement,
    title: t(tooltipTitle),
    onClose: handleTooltipClose,
    onOpen: handleTooltipOpen,
    open: open,
    disableFocusListener: true,
    classes: {
      popper: classes.tooltipWrapper,
      tooltip: classes.tooltip
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: buttonWrapperClassName
  }, /*#__PURE__*/React.createElement(Button, _extends({
    onClick: handleButtonClick,
    className: allowButtonClasses && (buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.variant) === "outlined" ? classes.buttonOutlined : allowButtonClasses ? classes.button : ""
  }, buttonProps, {
    onMouseLeave: handleTooltipClose
  }), typeof children === "string" ? t(children) : children)));
};
const styles = theme => ({
  button: {
    backgroundColor: theme.palette.secondary.dark,
    ...CORE_BUTTON_STYLES,
    minWidth: "unset",
    "&:hover": {
      cursor: "pointer",
      backgroundColor: "#145DFF"
    },
    "&:focus": {
      cursor: "pointer",
      backgroundColor: "#1F64FF"
    }
  },
  buttonOutlined: {
    borderColor: theme.palette.secondary.dark,
    ...CORE_BUTTON_STYLES,
    minWidth: "unset",
    height: 40,
    minHeight: 40,
    "&:hover": {
      cursor: "pointer",
      borderColor: theme.palette.secondary.light
    }
  },
  tooltipWrapper: {
    maxWidth: 185
  },
  tooltip: {
    textAlign: "center"
  },
  buttonWrapper: {
    margin: "auto"
  }
});
export default withStyles(styles)(withi18n(TooltipButton));
TooltipButton.propTypes = {
  classes: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
  tooltipTitle: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.node, PropTypes.string]),
  buttonProps: PropTypes.object,
  placement: PropTypes.string.isRequired,
  buttonWrapperClassName: PropTypes.string,
  allowButtonClasses: PropTypes.bool
};